<template>
  <div class="modal" :class="{'is-active': openModal, 'allow-overflow': allowOverflow}">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card" :class="{ 'allow-overflow': allowOverflow }" :style="style">
      <header class="modal-card-head">
        <p class="modal-card-title">{{title}}</p>
        <button class="delete" type="button" aria-label="close" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body" :class="{ 'allow-overflow': allowOverflow }">
        <slot></slot>
      </section>
      <footer class="modal-card-foot is-flex is-justify-content-end" style="flex-wrap: wrap;">
        <button class="button" type="button" @click="$emit('close')"><font-awesome-icon icon="times" /><span v-if="!noAction">Chiudi</span><span v-else>Chiudi</span></button>
        <button v-if="!noAction" class="button is-primary" type="button" @click="success()" :class="[{'is-loading': loading}]" :disabled="loading || disabled"><font-awesome-icon icon="save" />{{saveLabel}}</button>
        <div v-if="hasDisclaimer" class="has-text-right mt-2" style="width: 100%;">
          <small class="has-text-danger is-abbr-like">Il salvataggio sarà effettivo</small>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    openModal: {
      type: Boolean,
      required: true
    },
    saveLabel: {
      type: String,
      default: 'Salva'
    },
    loading: {
      type: Boolean,
      default: false
    },
    style: {
      type: [String, Object]
    },
    noAction: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasDisclaimer: {
      type: Boolean,
      default: false
    },
    allowOverflow: {
      type: Boolean,
      default: false
    }
  },

  emits: ['success', 'close'],

  methods: {
    success() {
      this.$emit('success')
      //this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.modal.allow-overflow {
  overflow: visible;
}

.modal-card.allow-overflow {
  overflow: visible;
}

.modal-card-body.allow-overflow {
  overflow: visible;
}
</style>